import { cloneElement, JSX } from 'react';
import classNames from 'classnames';

import { TabsBase } from '../../tabs/tabs-base';

import { VerticalTabsNavigation } from '../vertical-tabs-navigation/vertical-tabs-navigation';
import { VerticalTabsProps, VerticalTabsState } from './vertical-tabs.config';

export const removeDisabledClassFromContentBlock = (elements: NodeListOf<Element>) => {
  setTimeout(() => {
    elements.forEach((element) => {
      element.className = element?.className?.replace('is-disabled', '');
    });
  }, 500);
};

class VerticalTabs extends TabsBase<VerticalTabsProps, VerticalTabsState> {
  componentDidUpdate(prevProps: Readonly<VerticalTabsProps>): void {
    if (this.shouldUpdateActiveOnAuthorPanelSwitch(prevProps)) {
      this.setState({ activeIndex: Number(this.props.activeIndexFromAuthorPanel) });
    }

    if (this.props.isInEditorMode) {
      removeDisabledClassFromContentBlock(
        window.parent?.document.querySelectorAll('[title="Vertical Tabs Content Block"]')
      );
    }
  }

  renderTabContentBlock = (component: JSX.Element, index: number) => {
    const active = index === this.state.activeIndex;
    const renderElement = this.props.isInEditorMode || active;

    return (
      renderElement && (
        <div
          data-testid="vertical-tabs-content"
          className={classNames('snowflake-vertical-vertical-tabs-content-wrapper', {
            'hidden-vertical-tabs-content': this.props.isInEditorMode && !active,
          })}
          key={component.key}
        >
          {cloneElement(component, {
            isInEditor: this.props.isInEditor,
            hasGradientBackground: this.props.hasGradientBackground,
            hasMidBlueBackground: this.props.hasMidBlueBackground,
          })}
        </div>
      )
    );
  };

  render() {
    return (
      <div
        aria-label={this.props.accessibilityLabel}
        className="snowflake-vertical-tabs"
        data-testid="vertical-tabs"
        {...this.tabContainerProps}
      >
        <div className="snowflake-vertical-tabs-content">
          <div data-testid="vertical-tabs-navigation" className="snowflake-vertical-vertical-tabs-navigation-wrapper">
            <VerticalTabsNavigation
              cqItemsOrder={this.props.cqItemsOrder}
              activeItemIndex={this.state.activeIndex}
              setActiveItemIndex={this.setActiveTab}
              cqItems={this.props.cqItems}
              hasGradientBackground={this.props.hasGradientBackground}
              hasMidBlueBackground={this.props.hasMidBlueBackground}
            />
          </div>

          {this.childComponents.map(this.renderTabContentBlock)}
        </div>
        {this.placeholderComponent}
      </div>
    );
  }
}

export default VerticalTabs;
